//#region Libraries
import { useNavigate } from "react-router-dom";
//#endregion
//#region Styles
import { Row, TitleSection } from "components/styles";
import {
    Container,
    Content,
    CampusCard
} from "views/Configuracion/components/CampusListView/components/CampusOptionList/styles";
//#endregion
//#region Icons
import ActivityIcon from "icons/ActivityIcon";
import EditIcon from "icons/EditIcon";
//#endregion
//#region Services
import { configSessionStorage } from "services/storage/config";
//#endregion
//#region Utils
import ABSOLUTE_PATHS from "routes/utils/absolutePaths";
import GuideMessage from "../GuideMessage/GuideMessage";
//#endregion

const SpaceOptionList = ({
    spaceList,
    campusName
}) => {
    //#region Custom hooks
    const navigate = useNavigate();
    //#endregion
    //#region Functions
    const goToUpdateSpaceForm = spaceId => {
        configSessionStorage.spaceAdmin.spaceId.set(spaceId);
        navigate(ABSOLUTE_PATHS.SETTINGS_SPACE_ADMIN_UPDATE);
    }
    //#endregion
    return (
        <Container>
            <TitleSection textAlign="center">Campus {campusName}</TitleSection>
            {spaceList.length === 0
                ? <GuideMessage />
                : <Content>
                    {spaceList.map(({ id, name, active }) => (
                        <CampusCard className={!active && "disabled"} key={id}>
                            <span className="icon"><ActivityIcon /></span>
                            <Row justifyContent="flex-start" gap="15px">
                                <h5 className="text">{name}</h5>
                                <span
                                    className="button"
                                    onClick={() => goToUpdateSpaceForm(id)}><EditIcon /></span>
                            </Row>
                        </CampusCard>
                    ))}
                </Content>}
        </Container>
    );
}

export default SpaceOptionList;